import { isUserCustomer } from '@rd-web-markets/shared/dist/util/user/userUtils';
import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
const checkboxFieldNamesClient = ['is_financial', 'is_technical'];
const checkboxFieldNamesInternalUsers = ['is_financial', 'is_technical', 'is_internal_only'];
const checkboxTranslationValues = {
  is_financial: 'financial',
  is_technical: 'technical'
  // is_internal_only: 'internal_only' // option only relevant for internal users
};
const TypeCheckboxes = _ref => {
  let {
    body,
    setBody,
    labelText,
    userClaimGroupAbilities
  } = _ref;
  const user = useSelector(state => state.auth.user);
  const documentTypeAbilities = userClaimGroupAbilities?.pages?.any;
  let checkboxFieldNames = checkboxFieldNamesClient;
  const hasDocumentTypeAbilities = !!documentTypeAbilities;
  if (isUserCustomer(user) && hasDocumentTypeAbilities) {
    checkboxFieldNames = checkboxFieldNamesClient.filter(fieldName => {
      if (fieldName === 'is_financial') return documentTypeAbilities.canAccessFinancialDocuments;
      if (fieldName === 'is_technical') return documentTypeAbilities.canAccessTechnicalDocuments;
      return false;
    });
  }

  // option only relevant for internal users
  if (!isUserCustomer(user)) {
    checkboxTranslationValues['is_internal_only'] = 'internal_only';
    checkboxFieldNames = checkboxFieldNamesInternalUsers;
  }
  const onlyOneDocumentTypeAvailable = checkboxFieldNames.length === 1 && isUserCustomer(user);
  const {
    t
  } = useTranslation();
  const changeCheckbox = e => {
    return setBody(body => ({
      ...body,
      [e.target.name]: e.target.checked
    }));
  };
  return checkboxFieldNames.map((fieldName, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement(Form.Group, {
      className: "mb-2",
      as: Row
    }, /*#__PURE__*/React.createElement(Form.Label, {
      column: "md",
      md: 3
    }, index === 0 && t(labelText)), /*#__PURE__*/React.createElement(Col, {
      md: {
        span: 5,
        offset: 4
      }
    }, /*#__PURE__*/React.createElement(Form.Check, {
      id: fieldName,
      type: "checkbox",
      name: fieldName,
      checked: body[fieldName] || false,
      value: body[fieldName] || false,
      onChange: changeCheckbox,
      label: t(checkboxTranslationValues[fieldName]),
      disabled: onlyOneDocumentTypeAvailable
    }))));
  });
};
export default TypeCheckboxes;